export default "__VITE_ASSET__DIVxAnsr__"